import _ from 'lodash';
import { DateRange } from 'rsuite/esm/DateRangePicker/types';
import {
  downloadPickupList as downloadPickupListPdf,
  getPickupLists,
} from '../../../api/orders/pickuplist/pickupList';
import {
  PickupList,
  PickupListDateType,
  PickupListDownloadRequest,
  PickupListsRequest,
  PickupPlace,
} from '../../../api/orders/pickuplist/pickupListTypes';
import { toDateTimeApiFormat } from '../../../services/dateUtils';
import { downloadData } from '../../../utils/downloadData';

const PDF_TYPE = 'application/pdf';
const DEFAULT_FILE_NAME = 'pickup-list.pdf';
const FILE_NAME_PATTERN = /filename="?([^";]+)"?/i;

function toFileName(contentDisposition: string | undefined): string {
  const match = contentDisposition ? FILE_NAME_PATTERN.exec(contentDisposition) : null;

  return match ? match[1] : DEFAULT_FILE_NAME;
}

export function toPickupListsRequest(
  range: DateRange,
  dateType: PickupListDateType,
  marketplaceCode?: string,
): PickupListsRequest {
  return {
    dateType,
    from: toDateTimeApiFormat(range[0]),
    to: toDateTimeApiFormat(range[1]),
    marketplaceCode,
  };
}

export function formatSender(place: PickupPlace): string {
  return _.compact([place.senderName, place.senderCompany]).join(', ');
}

export function formatAddress(place: PickupPlace): string {
  const postcodeAndCity = _.compact([place.postcode, place.city]).join(' ');

  return _.compact([place.street, postcodeAndCity, place.countryCode]).join(', ');
}

export async function loadPickupLists(
  request: PickupListsRequest,
  signal?: AbortSignal,
): Promise<PickupList[]> {
  const response = await getPickupLists(request, signal);

  return response.pickupLists;
}

export async function downloadPickupList(
  request: PickupListDownloadRequest,
  signal?: AbortSignal,
): Promise<void> {
  const response = await downloadPickupListPdf(request, signal);

  downloadData(response.data, PDF_TYPE, toFileName(response.headers['content-disposition']));
}
